/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Wind_DescInputs */

const en_ui_color_by_wind_desc = /** @type {(inputs: Ui_Color_By_Wind_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tail, cross, head · map only`)
};

const de_ui_color_by_wind_desc = /** @type {(inputs: Ui_Color_By_Wind_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rücken-, Seiten-, Gegenwind · nur Karte`)
};

/**
* | output |
* | --- |
* | "Tail, cross, head · map only" |
*
* @param {Ui_Color_By_Wind_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_wind_desc = /** @type {((inputs?: Ui_Color_By_Wind_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Wind_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_wind_desc(inputs)
	return de_ui_color_by_wind_desc(inputs)
});